import { render, staticRenderFns } from "./noodBseg.vue?vue&type=template&id=a9ffa89e&scoped=true"
import script from "./noodBseg.vue?vue&type=script&lang=js"
export * from "./noodBseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ffa89e",
  null
  
)

export default component.exports